<template>
  <modal>
    <div class="text-center">
      <progressive-img :src="require('@/assets/images/close.png')" />
    </div>
    <div class="modal-button flex justify-between mt-2">
      <a class="button-primary block w-full" @click="close()">閉じる</a>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  name: 'LandingModal',
  components: {
    Modal
  },
  props: {
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    close: function () {
      this.$store.dispatch('user/closeLanding')
      this.closeModal()
    }
  }
}
</script>
